import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromDietArray'
})
export class FromDietArrayPipe implements PipeTransform {
  transform(collection: Array<any>): string {
    const dietPrefix = 'Diets: ';
    return `${dietPrefix}${collection.map(x => x.name.trim()).join(', ')}`;
  }
}
